const getTranslatedText = (val, dictKey, dictMap) => {
    if (typeof val !== 'undefined' && val !== 'undefined') {
        return `${val} ${dictMap[dictKey]}`;
    }
    return '';
};

const getPitchingAfter = (val, dictKey, dictMap) => {
    // default values inningsPitched = '0.0', strikeOuts:0, earnedRuns: 0 from api
    // always show the stats, if undefined, default to 0
    const translatedText = dictMap[dictKey] || '';
    const normalizedVal = (typeof val !== 'undefined') ? val : 0;
    return `${normalizedVal} ${translatedText}`;
};

const getPitchingBefore = (val, dictKey, dictMap) => {
    // only show this when val > 0. all stats default to 0 from api
    if (typeof val !== 'undefined' && val > 0) {
        return `${dictMap[dictKey]}`;
    }
};

const getBattingAfter = (val, dictKey, dictMap, showNumberIfMoreThanOne = false) => {
    // all stats default to 0 from api
    // only show this when val > 0.
    // if showNumberIfMoreThanOne to true. only show number when val > 1
    const normalizedVal = (typeof val !== 'undefined') ? val : 0;
    const translatedText = dictMap[dictKey] || '';

    if (normalizedVal > 0) {
        if (showNumberIfMoreThanOne) {
            if (normalizedVal > 1) {
                return `${normalizedVal} ${translatedText}`;
            } else {
                return `${translatedText}`;
            }
        } else {
            return `${normalizedVal} ${translatedText}`;
        }
    } else {
        return undefined;
    }
};

const hittersStatsMap = {
    hits: ({ stats }) => {
        const {
            batting: {
                hits,
                atBats
            } = {}
        } = stats || {};
        const hitText = (typeof hits !== 'undefined') ? hits : '0';
        const atBatText = (typeof atBats !== 'undefined') ? atBats : '0';
        return `${hitText} - ${atBatText}`;
    },
    homeRuns: ({ dictMap, stats: { batting: { homeRuns } = {} } = {} } = {}) => {
        return getBattingAfter(homeRuns, 'hr', dictMap, true);
    },
    triples: ({ dictMap, stats: { batting: { triples } = {} } = {} } = {}) => {
        return getBattingAfter(triples, '3b', dictMap, true);
    },
    doubles: ({ dictMap, stats: { batting: { doubles } = {} } = {} } = {}) => {
        return getBattingAfter(doubles, '2b', dictMap, true);
    },
    baseOnBalls: ({ dictMap, stats: { batting: { baseOnBalls } = {} } = {} } = {}) => {
        return getBattingAfter(baseOnBalls, 'bb', dictMap, true);
    },
    hitByPitch: ({ dictMap, stats: { batting: { hitByPitch } = {} } = {} } = {}) => {
        return getBattingAfter(hitByPitch, 'hbp', dictMap, true);
    },
    rbi: ({ dictMap, stats: { batting: { rbi } = {} } = {} } = {}) => {
        return getBattingAfter(rbi, 'rbi', dictMap, true);
    },
    strikeOuts: ({ dictMap, stats: { batting: { strikeOuts } = {} } = {} } = {}) => {
        return getBattingAfter(strikeOuts, 'strikeOuts', dictMap, true);
    },
    runs: ({ dictMap, stats: { batting: { runs } = {} } = {} } = {}) => {
        return getBattingAfter(runs, 'runs', dictMap, true);
    },
    stolenBases: ({ dictMap, stats: { batting: { stolenBases } = {} } = {} } = {}) => {
        return getBattingAfter(stolenBases, 'sb', dictMap, true);
    },
    caughtStealing: ({ dictMap, stats: { batting: { caughtStealing } = {} } = {} } = {}) => {
        return getBattingAfter(caughtStealing, 'cs', dictMap, true);
    }
};

const pitchersStatsMap = {
    saves: ({ dictMap, stats: { pitching: { saves } = {} } = {} } = {}) => {
        return getPitchingBefore(saves, 'saves', dictMap);
    },
    blownSaves: ({ dictMap, stats: { pitching: { blownSaves } = {} } = {} } = {}) => {
        return getPitchingBefore(blownSaves, 'blownSaves', dictMap);
    },
    holds: ({ dictMap, stats: { pitching: { holds } = {} } = {} } = {}) => {
        return getPitchingBefore(holds, 'holds', dictMap);
    },
    losses: ({ dictMap, stats: { pitching: { losses } = {} } = {} } = {}) => {
        return getPitchingBefore(losses, 'losses', dictMap);
    },
    wins: ({ dictMap, stats: { pitching: { wins } = {} } = {} } = {}) => {
        return getPitchingBefore(wins, 'wins', dictMap);
    },
    ip: ({ dictMap, stats: { pitching: { inningsPitched } = {} } = {} } = {}) => getPitchingAfter(inningsPitched, 'ip', dictMap),
    strikeOuts: ({ dictMap, stats: { pitching: { strikeOuts } = {} } = {} } = {}) => getPitchingAfter(strikeOuts, 'strikeOuts', dictMap),
    pitcherK: ({ dictMap, stats: { pitching: { strikeOuts } = {} } = {} } = {}) => getPitchingAfter(strikeOuts, 'strikeOuts', dictMap),
    earnedRuns: ({ dictMap, stats: { pitching: { earnedRuns } = {} } = {} } = {}) => getPitchingAfter(earnedRuns, 'er', dictMap),
    numberOfPitches: ({ dictMap, stats: { pitching: { numberOfPitches } = {} } = {} } = {}) => getPitchingAfter(numberOfPitches, 'numberOfPitches', dictMap),
    strikes: ({ dictMap, stats: { pitching: { strikes } = {} } = {} } = {}) => getPitchingAfter(strikes, 'strikes', dictMap)

};

const probablePitchersStatsMap = {
    wins: ({ stats }) => {
        const {
            pitching: {
                wins,
                losses
            } = {}
        } = stats || {};
        const winText = (typeof wins !== 'undefined') ? wins : '0';
        const lossesText = (typeof losses !== 'undefined') ? losses : '0';
        return `${winText} - ${lossesText}`;
    },
    era: ({ dictMap, stats: { pitching: { era } = {} } = {} } = {}) => {
        return getTranslatedText(era, 'era', dictMap);
    },
    strikeOuts: ({ dictMap, stats: { pitching: { strikeOuts } = {} } = {} } = {}) => {
        return getTranslatedText(strikeOuts, 'strikeOuts', dictMap);
    },
    pitcherK: ({ dictMap, stats: { pitching: { strikeOuts } = {} } = {} } = {}) => {
        return getTranslatedText(strikeOuts, 'strikeOuts', dictMap);
    },
    ip: ({ dictMap, stats: { pitching: { inningsPitched } = {} } = {} } = {}) => getPitchingAfter(inningsPitched, 'ip', dictMap),
    baseOnBalls: ({ dictMap, stats: { pitching: { baseOnBalls } = {} } = {} } = {}) => {
        return getBattingAfter(baseOnBalls, 'bb', dictMap, true);
    },
    earnedRuns: ({ dictMap, stats: { pitching: { earnedRuns } = {} } = {} } = {}) => getPitchingAfter(earnedRuns, 'er', dictMap)
};

const statsMapsDuel = {
    hittersStatsMap,
    pitchersStatsMap,
    probablePitchersStatsMap
};

export {
    hittersStatsMap,
    pitchersStatsMap,
    statsMapsDuel,
    probablePitchersStatsMap
};
